module.exports = __webpack_public_path__ + "media/img/android-icon-36x36-b9a0d52e2a1a793c1f0c7b001a94155f.png";